<template>
  <div>
    <div class="d-flex flex-row justify-content-between align-items-center">
      <div class="text__criteria-title">
        {{ criterion.title }}
      </div>
      <div class="elipsis-criterion btn__dropdown-toggle">
        <BaseEllipsis v-if="!disabled" :size="'xl'" class="ml-2">
          <b-dropdown-item v-if="canEdit" @click.prevent.stop="showModalEditCriterion = true">
            Edit
          </b-dropdown-item>
          <b-dropdown-item v-if="canRemove" @click.prevent.stop="showModalDeleteCriterion = true">
            Remove
          </b-dropdown-item>
        </BaseEllipsis>
      </div>
    </div>

    <span v-show="isShow">
      <div class="ml-4 mt-1 text-dark text__pass-criteria text-pre-wrap">
        <b>Pass</b> — {{ criterion.pass_criterion }}
      </div>
      <div class="ml-4 mt-1 text-dark text__not-yet-criteria text-pre-wrap">
        <b>Not yet</b> — {{ criterion.not_yet_criterion }}
      </div>
    </span>

    <b-button
      variant="link"
      class="btn btn-link btn-link-primary pl-0 pr-0"
      @click="isShow = !isShow"
      >{{ isShow ? 'Hide passing criteria' : 'Show passing criteria' }}</b-button
    >

    <ModalCreateOrUpdateCriteria
      :show.sync="showModalEditCriterion"
      :ultimate-learning-outcome="learningOutcome"
      :criteria="criterion"
      :show-section-align="false"
    />

    <ModalDeleteCriterion
      :show.sync="showModalDeleteCriterion"
      :criteria="criterion"
      title="Remove this criterion from the post"
      sub-title="Are you sure that you want to remove this criterion from the post?"
      description='Click at the "Remove" button to remove this criterion from the post.'
      delete-action-text="Remove"
      @emitDeleteCriterion="$emit('remove')"
    />
  </div>
</template>

<script>
import BaseEllipsis from '@/components/base-components/BaseEllipsis';
import ModalCreateOrUpdateCriteria from '@/components/LearningOutcome/ModalCreateOrUpdateCriteria';
import ModalDeleteCriterion from './ModalDeleteCriterion';

export default {
  components: {
    BaseEllipsis,
    ModalCreateOrUpdateCriteria,
    ModalDeleteCriterion
  },

  props: {
    criterion: {
      type: Object,
      default: () => ({})
    },

    disabled: {
      type: Boolean,
      default: false
    },

    canEdit: {
      type: Boolean,
      default: true
    },

    canRemove: {
      type: Boolean,
      default: true
    },

    learningOutcome: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      isShow: true,
      showModalEditCriterion: false,
      showModalDeleteCriterion: false
    };
  }
};
</script>
